import React, { useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import MediaViewer from '../../../../shared/media-viewer/MediaViewer';
import RedirectUrlLink from '../../../../shared/redirect-url-link/Redirect-Url-Link';
import CustomPhoneNoView from '../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import {
  allRestaurantSelector,
  allUIBuilderPagesSelector,
  allSpaInfoSelector,
} from '../../../property/propertySlice';
import { inRoomDiningMenuSelector } from '../../../services/servicesSlice';

const OfferDetails = ({ tabValue, offer, getOffersType }) => {
  const [notificationList, setNotificationList] = useState(offer.notification);
  const allRestaurants = useSelector(allRestaurantSelector);
  const allUIBuilderPages = useSelector(allUIBuilderPagesSelector);
  const inRoomDiningKinds = useSelector(inRoomDiningMenuSelector);
  const allSpaInfo = useSelector(allSpaInfoSelector);

  const getDate = (date) => {
    if (date) return moment.unix(date).format('DD MMM, YYYY');
    if (notificationList.length > 0) {
      const lastNotificationDate = notificationList[notificationList.length - 1].createdAt;
      return moment.unix(lastNotificationDate).format('DD MMM, YYYY - hh:mm A');
    }
    return '---';
  };

  const onClickExpand = (notificationObj, notificationListNdx) => {
    const currNotification = [...notificationList];
    currNotification[notificationListNdx] = {
      ...notificationObj,
      expand: notificationObj.expand === undefined ? true : !notificationObj.expand,
    };
    setNotificationList(currNotification);
  };

  const upperCaseName = (value) => {
    return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
  };

  const setType = (cta) => {
    if (cta.emailId) return cta.emailId;
    if (cta.phoneNumber) return cta.phoneNumber;
    if (cta.redirectTo) return cta.redirectTo;
  };

  const enqTitle = (title) => {
    if (title === 'phone') return 'Phone Number';
    if (title === 'email') return 'Email Id';
  };

  return (
    <div className='row mx-4 mt-4'>
      {tabValue === 0 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Title</div>
            <div className='details-value preview-breaks'>{offer.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Type</div>
            <div className='details-value'>{getOffersType(offer?.type)}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>{offer.description}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Highlights</div>
            <div className='details-value preview-breaks'>{offer.highLights || '---'}</div>
          </div>
          {offer?.customAttributes &&
            offer?.customAttributes?.length > 0 &&
            offer?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      )}
      {tabValue === 1 && (
        <>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>CTA</div>
            {offer?.CTA?.status === 'Inactive' && <div className='details-value'>Inactive</div>}
            {offer?.CTA?.status !== 'Inactive' && (
              <div className='details-value'>{upperCaseName(offer.CTA.type)}</div>
            )}
          </div>
          {offer.CTA.type !== 'OK' && offer?.CTA?.status !== 'Inactive' && (
            <>
              {offer.CTA.type === 'ENQUIRE' && (
                <>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Email</div>
                    <div className='details-value'>{offer.CTA.emailId || '---'}</div>
                  </div>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label mt-2'>Phone</div>
                    <div className='details-value'>
                      {offer.CTA.phoneNumber ? (
                        <CustomPhoneNoView value={offer.CTA.phoneNumber} />
                      ) : (
                        '---'
                      )}
                    </div>
                  </div>
                </>
              )}

              {offer.CTA.type === 'REDEEM' && (
                <>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Redirect option</div>
                    <div className='details-value'>{setType(offer.CTA)}</div>
                  </div>
                  {offer?.CTA?.redirectTo === 'EXTERNAL URL' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>Redirect URL</div>
                      <div className='details-value'>
                        <RedirectUrlLink url={offer.CTA.URL} />
                      </div>
                    </div>
                  )}
                  {(offer?.CTA?.redirectTo === 'FLOW' || offer?.CTA?.redirectTo === 'MODULE') && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>Redirect Data</div>
                      <div className='details-value'>{offer.CTA.redirectData}</div>
                    </div>
                  )}

                  {offer?.CTA?.redirectTo === 'IN-APP PAGE' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>Redirect Data</div>
                      <div className='details-value'>
                        {allUIBuilderPages?.find((item) => item?.id === offer.CTA.redirectData)
                          ?.name || ''}
                      </div>
                    </div>
                  )}

                  {offer?.CTA?.redirectTo === 'MODULE' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>Module</div>
                      <div className='details-value'>
                        {(offer.CTA.redirectData === 'IRD' &&
                          inRoomDiningKinds?.find((item) => item?.id === offer.CTA.moduleId)
                            ?.name) ||
                          ''}
                        {(offer.CTA.redirectData === 'RESTAURANT' &&
                          allRestaurants?.find((item) => item?.id === offer.CTA.moduleId)?.name) ||
                          ''}
                        {(offer.CTA.redirectData === 'SPA' &&
                          allSpaInfo?.find((item) => item?.id === offer.CTA.moduleId)?.name) ||
                          ''}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          {offer?.CTA?.status !== 'Inactive' && (
            <div className='col-md-12 mt-4'>
              <div className='details-label'>Offer Card Placement</div>
              <div className='details-value'>
                {offer.CTA.cardPlacement.length > 0
                  ? offer.CTA.cardPlacement.map((e) => e).join(', ')
                  : '---'}
              </div>
            </div>
          )}
        </>
      )}
      {tabValue === 2 && (
        <>
          <div className='details-label'>Activity Status</div>
          {offer?.duration?.alwaysActive ? (
            <div className='details-value mt-2'>Always Active</div>
          ) : (
            <>
              <div className='details-value mt-2'>Scheduled Activity</div>

              <div className='row mt-4'>
                {offer?.duration?.startDate && (
                  <div className='col-md-6'>
                    <div className='details-label'>Start Date</div>
                    <div className='details-value mt-2'>
                      <p>
                        {moment(offer?.duration?.startDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                      </p>
                    </div>
                  </div>
                )}
                {offer?.duration?.endDate && (
                  <div className='col-md-6'>
                    <div className='details-label'>End Date</div>
                    <div className='details-value mt-2'>
                      <p>{moment(offer?.duration?.endDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}</p>
                    </div>
                  </div>
                )}
              </div>

              <div className='row mt-4'>
                <div className='col-md-6'>
                  <div className='details-label'>Start Time</div>
                  <div className='details-value mt-2'>
                    <p>
                      {moment(
                        offer?.duration?.startTime ? offer?.duration?.startTime : '00:00',
                        'HH:mm',
                      ).format('HH:mm A')}
                    </p>
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className='details-label'>End Time</div>
                  <div className='details-value mt-2'>
                    <p>
                      {moment(
                        offer?.duration?.endTime ? offer?.duration?.endTime : '23:59',
                        'HH:mm',
                      ).format('HH:mm A')}
                    </p>
                  </div>
                </div>
              </div>

              <div className='row mt-4'>
                <div className='col-md-6'>
                  <div className='details-label'>Scheduled For</div>
                  <div className='details-value mt-2'>
                    {offer.duration.everyday ? (
                      'Every Day'
                    ) : offer?.duration?.timings?.length === 7 ? (
                      'All Week Days'
                    ) : (
                      <>{offer?.duration?.timings?.map((timing) => timing.day).join(', ')}</>
                    )}
                  </div>
                </div>
              </div>

              <div className='row mt-4'>
                <div className='col-md-6'>
                  <div className='details-label'>Offer Timing</div>
                  <div className='details-value mt-2'>
                    {offer?.duration?.timings?.length > 0 && (
                      <p>{offer?.duration?.timings[0]?.offerTime}</p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}

      {tabValue === 3 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Email</div>
            <div className='details-value'>
              {offer.contact && offer.contact.email ? offer.contact.email : '---'}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Phone Number</div>
            <div className='details-value'>
              {offer.contact && offer.contact.phoneNumber ? (
                <CustomPhoneNoView value={offer.contact.phoneNumber} />
              ) : (
                '---'
              )}
            </div>
          </div>
        </>
      )}
      {tabValue === 4 && (
        <MediaViewer
          images={offer.images}
          videos={offer.videos}
          gifs={offer.gifs}
          enabledMediaTabs={['image']}
        />
      )}
      {tabValue === 5 && (
        <>
          {notificationList && notificationList.length > 0 ? (
            <>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Last Push Notification Date</div>
                <div className='details-value'>{getDate()}</div>
              </div>
              <div className='col-md-12 mt-4'>
                <div className='details-label'>Push Notifications History</div>
                {notificationList.map((value, notificationNdx) => (
                  <div className='offer-notification-accordion' key={notificationNdx}>
                    <div className='row' onClick={() => onClickExpand(value, notificationNdx)}>
                      <div className='col-md-6'>
                        <p>
                          Notification Name: <span className='notification-text'>{value.name}</span>
                        </p>
                      </div>
                      <div className='col-md-5 d-flex justify-content-end'>
                        <p>
                          Date:{' '}
                          <span className='notification-text'>{getDate(value.createdAt)}</span>
                        </p>
                      </div>
                      <div className='col-md-1 d-flex justify-content-end expand'>
                        {value.expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </div>
                      {value.expand && (
                        <div className='col-md-12'>
                          <span>Description</span>
                          <br />
                          <span className='notification-text'>{value.description}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p>No Notification added</p>
          )}
        </>
      )}
    </div>
  );
};

export default OfferDetails;
